// extracted by mini-css-extract-plugin
module.exports = {"container":"KioskFoodSuccessModal_container__22MPX","title":"KioskFoodSuccessModal_title__24xKu"};